import { IEntityReponse } from "../model/base/response/entity-response";

/**
 * Retorna o nickname da entidade em UPPERCASE
 * - Usa nickName se disponível, senão usa name como fallback
 *
 * @param entity - Objeto da entidade com nickName
 * @returns Nickname em UPPERCASE
 */
export const getFormattedEntityName = (entity: IEntityReponse | undefined): string => {
  if (!entity) {
    return '';
  }

  // Usa nickName se disponível, senão usa name como fallback
  const displayName = entity.nickName || entity.name;

  if (!displayName) {
    return '';
  }

  return displayName.toUpperCase();
};

// Tipos de entidade (mesmo mapeamento do docged.portal): 1=Prefeitura, 2=Câmara, 3=Autarquias, 4=Fundos
const ENTITY_POWER_LABELS: Record<number, string> = {
  1: 'Poder Executivo',
  2: 'Poder Legislativo',
};

/**
 * Subtítulo institucional exibido abaixo do nome da entidade no cabeçalho e no rodapé
 */
export const getEntityPowerLabel = (entity: IEntityReponse | undefined): string =>
  (entity?.entityType && ENTITY_POWER_LABELS[entity.entityType]) || 'Portal oficial';

/**
 * Logo da entidade: brasão cadastrado (base64) ou, na falta dele, o brasão do estado
 */
export const getEntityLogoSrc = (entity: IEntityReponse | undefined): string | undefined =>
  entity?.brandLogo ? `data:image/png;base64,${entity.brandLogo}` : entity?.stateBrandLogo;
